/** period-summary yanıtını Excel export formatına çevirir. */
export function periodSummaryToExportData(data) {
  const grand = data?.grand_totals || {
    dirty_kg: 0,
    clean_kg: 0,
    production_kg: 0,
    dirty_clean_diff_kg: 0,
    clean_production_diff_kg: 0,
  };

  const hotels = (data?.hotels || []).map((h) => ({
    name: h.hotel_name,
    Kirli: Number(h.dirty_kg) || 0,
    Temiz: Number(h.clean_kg) || 0,
    Üretim: Number(h.production_kg) || 0,
    dirty_clean_diff_kg: Number(h.dirty_clean_diff_kg) || 0,
    clean_production_diff_kg: Number(h.clean_production_diff_kg) || 0,
    departments: (h.departments || []).map((d) => ({
      name: d.department_name,
      Kirli: Number(d.dirty_kg) || 0,
      Temiz: Number(d.clean_kg) || 0,
      Fark: Number(d.difference_kg) || 0,
    })),
  }));

  const deptMap = new Map();
  hotels.forEach((h) => {
    h.departments.forEach((d) => {
      const cur = deptMap.get(d.name) || { name: d.name, Kirli: 0, Temiz: 0, Fark: 0 };
      cur.Kirli += d.Kirli;
      cur.Temiz += d.Temiz;
      cur.Fark += d.Fark;
      deptMap.set(d.name, cur);
    });
  });

  const deptChart = [...deptMap.values()].sort(
    (a, b) => (b.Kirli + b.Temiz) - (a.Kirli + a.Temiz)
  );

  return { grand, hotels, deptChart };
}

/** Dashboard çoklu ay verisini birleştirir. */
export function mergePeriodExportData(periodDataList) {
  const grand = { dirty_kg: 0, clean_kg: 0, production_kg: 0 };
  const hotelMap = new Map();
  const deptMap = new Map();

  periodDataList.forEach(({ data }) => {
    if (!data) return;
    const g = data.grand_totals || {};
    grand.dirty_kg += Number(g.dirty_kg) || 0;
    grand.clean_kg += Number(g.clean_kg) || 0;
    grand.production_kg += Number(g.production_kg) || 0;

    (data.hotels || []).forEach((h) => {
      const cur = hotelMap.get(h.hotel_name) || {
        name: h.hotel_name,
        Kirli: 0,
        Temiz: 0,
        Üretim: 0,
        departments: new Map(),
      };
      cur.Kirli += Number(h.dirty_kg) || 0;
      cur.Temiz += Number(h.clean_kg) || 0;
      cur.Üretim += Number(h.production_kg) || 0;

      (h.departments || []).forEach((d) => {
        const dc = cur.departments.get(d.department_name) || {
          name: d.department_name,
          Kirli: 0,
          Temiz: 0,
          Fark: 0,
        };
        dc.Kirli += Number(d.dirty_kg) || 0;
        dc.Temiz += Number(d.clean_kg) || 0;
        dc.Fark += Number(d.difference_kg) || 0;
        cur.departments.set(d.department_name, dc);

        const global = deptMap.get(d.department_name) || {
          name: d.department_name,
          Kirli: 0,
          Temiz: 0,
          Fark: 0,
        };
        global.Kirli += Number(d.dirty_kg) || 0;
        global.Temiz += Number(d.clean_kg) || 0;
        global.Fark += Number(d.difference_kg) || 0;
        deptMap.set(d.department_name, global);
      });
      hotelMap.set(h.hotel_name, cur);
    });
  });

  grand.dirty_clean_diff_kg = grand.dirty_kg - grand.clean_kg;
  grand.clean_production_diff_kg = grand.clean_kg - grand.production_kg;

  const hotels = [...hotelMap.values()]
    .map((h) => ({
      ...h,
      dirty_clean_diff_kg: h.Kirli - h.Temiz,
      clean_production_diff_kg: h.Temiz - h.Üretim,
      departments: [...h.departments.values()].sort(
        (a, b) => (b.Kirli + b.Temiz) - (a.Kirli + a.Temiz)
      ),
    }))
    .sort((a, b) => (b.Kirli + b.Temiz) - (a.Kirli + a.Temiz));

  const deptChart = [...deptMap.values()].sort(
    (a, b) => (b.Kirli + b.Temiz) - (a.Kirli + a.Temiz)
  );

  return { grand, hotels, deptChart };
}
